// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3DC0c","footer":"ModalCreateQualiphyProcedure_footer__mkp0N","additionData":"ModalCreateQualiphyProcedure_additionData__1UFYz"};